import {
  IconAirplane,
  IconAlphaA,
  IconAlphaB,
  IconAlphaC,
  IconAlphaD,
  IconAlphaE,
  IconAlphaF,
  IconAlphaG,
  IconAlphaH,
  IconAlphaI,
  IconAlphaJ,
  IconAlphaK,
  IconAlphaL,
  IconAlphaM,
  IconAlphaN,
  IconAlphaO,
  IconAlphaP,
  IconAlphaQ,
  IconAlphaR,
  IconAlphaS,
  IconAlphaT,
  IconAlphaU,
  IconAlphaV,
  IconAlphaW,
  IconAlphaX,
  IconAlphaY,
  IconAlphaZ,
  IconBaby,
  IconBag,
  IconBalloon,
  IconBeer,
  IconBone,
  IconBookmarkCheckmark,
  IconBookmarkFolded,
  IconBottle,
  IconBowl,
  IconBread,
  IconBreadOff,
  IconBroccoli,
  IconCake,
  IconCar,
  IconCarrot,
  IconCashCheckmark,
  IconCashPlus,
  IconChampagne,
  IconCheckmarkCircle,
  IconCheese,
  IconChef,
  IconChefHat,
  IconCherries,
  IconChili,
  IconCloche,
  IconCoat,
  IconCocktail,
  IconCoffee,
  IconCrab,
  IconCreditCard,
  IconDog,
  IconEdit,
  IconExclamationTriangle,
  IconFaceCool,
  IconFaceHappy,
  IconFaceSick,
  IconFire,
  IconFish,
  IconFlag,
  IconFlower,
  IconGift,
  IconGlass,
  IconGraduationHat,
  IconGrapes,
  IconHeart,
  IconKey,
  IconKnife,
  IconLeafOff,
  IconLightning,
  IconLock,
  IconNotAllowed,
  IconNumber0,
  IconNumber1,
  IconNumber2,
  IconNumber3,
  IconNumber4,
  IconNumber5,
  IconNumber6,
  IconNumber7,
  IconNumber8,
  IconNumber9,
  IconPairing,
  IconPeopleFamily,
  IconPersonArrow,
  IconPhone,
  IconPhoneIncoming,
  IconPhoneOff,
  IconPhoneRinging,
  IconPhoneVoicemail,
  IconPlate,
  type IconProps,
  IconShieldPlus,
  IconShrimp,
  IconStar,
  IconSushi,
  IconTea,
  IconTent,
  IconTheater,
  IconTicket,
  IconTransfer,
  IconUmbrella,
  IconVip,
  IconWheelchair,
  IconWineBottle,
  IconWineGlass,
} from '@tocktix/pantry';

interface IconSet {
  [iconName: string]: React.FunctionComponent<IconProps>;
}

const iconSet: IconSet = {
  IconTagAcceptPayment: IconCashCheckmark,
  IconTagAirport: IconAirplane,
  IconTagAlphaA: IconAlphaA,
  IconTagAlphaB: IconAlphaB,
  IconTagAlphaC: IconAlphaC,
  IconTagAlphaD: IconAlphaD,
  IconTagAlphaE: IconAlphaE,
  IconTagAlphaF: IconAlphaF,
  IconTagAlphaG: IconAlphaG,
  IconTagAlphaH: IconAlphaH,
  IconTagAlphaI: IconAlphaI,
  IconTagAlphaJ: IconAlphaJ,
  IconTagAlphaK: IconAlphaK,
  IconTagAlphaL: IconAlphaL,
  IconTagAlphaM: IconAlphaM,
  IconTagAlphaN: IconAlphaN,
  IconTagAlphaO: IconAlphaO,
  IconTagAlphaP: IconAlphaP,
  IconTagAlphaQ: IconAlphaQ,
  IconTagAlphaR: IconAlphaR,
  IconTagAlphaS: IconAlphaS,
  IconTagAlphaT: IconAlphaT,
  IconTagAlphaU: IconAlphaU,
  IconTagAlphaV: IconAlphaV,
  IconTagAlphaW: IconAlphaW,
  IconTagAlphaX: IconAlphaX,
  IconTagAlphaY: IconAlphaY,
  IconTagAlphaZ: IconAlphaZ,
  IconTagBaby: IconBaby,
  IconTagBag: IconBag,
  IconTagBalloon: IconBalloon,
  IconTagBeer: IconBeer,
  IconTagBirthday: IconGift,
  IconTagBone: IconBone,
  IconTagBookmark: IconBookmarkFolded,
  IconTagBottle: IconBottle,
  IconTagBowl: IconBowl,
  IconTagBread: IconBread,
  IconTagBroccoli: IconBroccoli,
  IconTagCake: IconCake,
  IconTagCampers: IconTent,
  IconTagCar: IconCar,
  IconTagCardOnFile: IconCreditCard,
  IconTagCarrot: IconCarrot,
  IconTagCheckmark: IconCheckmarkCircle,
  IconTagCheers: IconChampagne,
  IconTagCheese: IconCheese,
  IconTagChef: IconChef,
  IconTagChefHat: IconChefHat,
  IconTagCherry: IconCherries,
  IconTagChili: IconChili,
  IconTagClear: IconShieldPlus,
  IconTagCoat: IconCoat,
  IconTagCocktail: IconCocktail,
  IconTagCoffee: IconCoffee,
  IconTagConfirmed: IconBookmarkCheckmark,
  IconTagCool: IconFaceCool,
  IconTagCrab: IconCrab,
  IconTagDinner: IconCloche,
  IconTagDog: IconDog,
  IconTagExit: IconPersonArrow,
  IconTagFamily: IconPeopleFamily,
  IconTagFire: IconFire,
  IconTagFish: IconFish,
  IconTagFlag: IconFlag,
  IconTagFlower: IconFlower,
  IconTagGlass: IconGlass,
  IconTagGraduation: IconGraduationHat,
  IconTagGrape: IconGrapes,
  IconTagHappy: IconFaceHappy,
  IconTagHeart: IconHeart,
  IconTagIncomingCall: IconPhoneIncoming,
  IconTagKey: IconKey,
  IconTagKnife: IconKnife,
  IconTagLightening: IconLightning,
  IconTagLock: IconLock,
  IconTagNoBread: IconBreadOff,
  IconTagNotAllowed: IconNotAllowed,
  IconTagNoCall: IconPhoneOff,
  IconTagNoLeaf: IconLeafOff,
  IconTagNumeric0: IconNumber0,
  IconTagNumeric1: IconNumber1,
  IconTagNumeric2: IconNumber2,
  IconTagNumeric3: IconNumber3,
  IconTagNumeric4: IconNumber4,
  IconTagNumeric5: IconNumber5,
  IconTagNumeric6: IconNumber6,
  IconTagNumeric7: IconNumber7,
  IconTagNumeric8: IconNumber8,
  IconTagNumeric9: IconNumber9,
  IconTagPairing: IconPairing,
  IconTagPayment: IconCashPlus,
  IconTagPhone: IconPhone,
  IconTagPhoneRing: IconPhoneRinging,
  IconTagPlate: IconPlate,
  IconTagShrimp: IconShrimp,
  IconTagSick: IconFaceSick,
  IconTagStar: IconStar,
  IconTagSushi: IconSushi,
  IconTagTea: IconTea,
  IconTagTheater: IconTheater,
  IconTagTicket: IconTicket,
  IconTagTransfer: IconTransfer,
  IconTagUmbrella: IconUmbrella,
  IconTagVip: IconVip,
  IconTagVoicemail: IconPhoneVoicemail,
  IconTagWarning: IconExclamationTriangle,
  IconTagWheelchair: IconWheelchair,
  IconTagWineBottle: IconWineBottle,
  IconTagWineGlass: IconWineGlass,
  IconTagWriter: IconEdit,
};

/**
 * @deprecated Use dashboard/src/js/components/inputs/tagIcons.tsx instead
 * See https://github.com/tocktix/admin/pull/42003/changes#diff-6a75b9ebd303c3ca2ba92a5e251c21d5846d54cec21bfcf5d43e09c3fdad9bbaR21-R30
 * for an example of migrating away from this icon set
 **/
export default iconSet;
